import { useState } from 'react'
import effects from 'app/effects/effects'
import { useDispatch } from 'react-redux'
import { UPDATE_USER_DATA } from 'app/auth/store/actions'
import { useResultDispatch } from 'commons/useResultDispatch'
import { compose, view, set, lensPath, lensProp } from 'ramda'
import {
  logoutUser,
  setSuspendedStatus,
  updateUserRoles,
} from '../app/auth/store/actions'
import { setPlace } from '../app/store/actions/place.actions'
import {
  getSuspendErrorStatus,
  isSuspendError,
} from '../app/auth/suspendStatus'
import {
  isFreeTierPlaceTeamMemberSignInError,
  teamMemberSignInErrorMessage,
} from '../app/auth/paidPlanAccess'
import { loadProfileAndPlace } from '../app/auth/authAPI'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'

export const STATUS_INVITED = 1
export const STATUS_ACCEPTED = 2
export const STATUS_REJECTED = 3
export const STATUS_CANCELED = 4

export const useTransfer = () => {
  const [state, setState] = useState({
    createLoading: false,
    isSeenLoading: false,
    loading: {
      [STATUS_INVITED]: false,
      [STATUS_ACCEPTED]: false,
      [STATUS_REJECTED]: false,
      [STATUS_CANCELED]: false,
    },
  })
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const { dispatchError } = useResultDispatch()

  const createStatusButton = (transferRequestId, status) => [
    view(lensPath(['loading', String(status)]))(state),
    async () => {
      compose(setState, set(lensPath(['loading', String(status)]), true))(state)
      return effects.apis
        .changeTransferStatus({ transferRequestId, status })
        .then(async () => {
          compose(
            setState,
            set(lensPath(['loading', String(status)]), false),
          )(state)
          await fetchMy()
        })
        .catch((...props) => {
          compose(
            setState,
            set(lensPath(['loading', String(status)]), false),
          )(state)
          dispatchError(props)
        })
    },
  ]

  const createButton = () => [
    view(lensProp('createLoading'))(state),
    async (inviteeUserId, password) => {
      compose(setState, set(lensProp('createLoading'), true))(state)
      return effects.apis
        .createUserTransfer({ inviteeUserId, password })
        .then(async () => {
          compose(setState, set(lensProp('createLoading'), false))(state)
          await fetchMy()
        })
        .catch((e) => {
          compose(setState, set(lensProp('createLoading'), false))(state)
          dispatchError(e)
          throw e
        })
    },
  ]

  const createIsSeenButton = () => [
    view(lensProp('isSeenLoading'))(state),
    async (transferRequestId) => {
      compose(setState, set(lensProp('isSeenLoading'), true))(state)
      return effects.apis
        .setTransferIsSeen({ transferRequestId })
        .then(async () => {
          compose(setState, set(lensProp('isSeenLoading'), false))(state)
          await fetchMy()
        })
        .catch((e) => {
          compose(setState, set(lensProp('isSeenLoading'), false))(state)
          throw e
        })
    },
  ]

  const fetchMy = () => {
    loadProfileAndPlace()
      .then(({ user, place }) => {
        dispatch({
          type: UPDATE_USER_DATA,
          payload: user,
        })
        compose(dispatch, updateUserRoles)(user)
        compose(dispatch, setPlace)(place)
      })
      .catch((error) => {
        if (isSuspendError(error)) {
          compose(dispatch, setSuspendedStatus, getSuspendErrorStatus)(error)
          dispatch(logoutUser())
        } else if (isFreeTierPlaceTeamMemberSignInError(error)) {
          dispatch(logoutUser())
          compose(
            dispatch,
            (message) => MessageAlert.showError({ message }),
            teamMemberSignInErrorMessage(formatMessage),
          )(error)
        }
      })
  }

  return {
    createStatusButton,
    createIsSeenButton,
    createButton,
  }
}

export default useTransfer
